import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { GlobeIcon, NetworkIcon, ShieldCheckIcon, VideoIcon, PhoneCallIcon, ArrowRightIcon } from 'lucide-react';
const services = [{
  title: 'Business Internet',
  description: 'Stop overpaying for bandwidth. We compare rates across all major providers to find the fastest, most cost-effective internet plan for your business.',
  icon: GlobeIcon
}, {
  title: 'Ethernet-Fiber',
  description: 'Get dedicated fiber at wholesale rates. We negotiate enterprise-grade connections with guaranteed uptime — often at 20-40% less than retail pricing.',
  icon: NetworkIcon
}, {
  title: 'Network Security',
  description: 'Consolidate your security spend. We bundle enterprise-grade protection into your telecom package, eliminating redundant vendor costs.',
  icon: ShieldCheckIcon
}, {
  title: 'UCaaS',
  description: 'Replace expensive legacy phone systems. Unified Communications cuts costs by combining phone, video, and messaging into one affordable platform.',
  icon: VideoIcon
}, {
  title: 'Business Phone',
  description: "Slash your phone bill without sacrificing quality. We source business phone systems with crystal-clear voice at a fraction of what you're paying now.",
  icon: PhoneCallIcon
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function ServicesSection() {
  return <section className="py-24 bg-white" id="services" data-id="element-307">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-308">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-309">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-310">
            Where We Find Your Savings
          </h2>
          <p className="text-lg text-slate-600" data-id="element-311">
            Every telecom category is an opportunity to reduce costs. We
            optimize each one so you get better service for less.
          </p>
        </div>

        <motion.div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} data-id="element-312">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <motion.div key={index} variants={itemVariants} className="bg-slate-50 rounded-2xl p-8 border border-slate-100 flex flex-col h-full" data-id="element-313">
                <div className="w-14 h-14 bg-white rounded-xl shadow-sm border border-slate-100 flex items-center justify-center mb-6" data-id="element-314">
                  <Icon className="w-7 h-7 text-primary" data-id="element-315" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-316">
                  {service.title}
                </h3>
                <p className="text-slate-600 mb-8 flex-grow leading-relaxed" data-id="element-317">
                  {service.description}
                </p>
                <a href="#" className="inline-flex items-center text-primary font-semibold hover:text-primary-dark transition-colors group mt-auto" data-id="element-318">
                  Learn More
                  <ArrowRightIcon className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform" data-id="element-319" />
                </a>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}